import {
    AlwaysShowBccPolicySettingId,
    AtMentionsPolicySettingId,
    FocusedInboxPolicySettingId,
    KeyboardStylesPolicySettingId,
    NotificationsPolicySettingId,
    OcpsPolicyFeature,
    PresencePolicySettingId,
    PrivacyPolicySettingId,
    ReplyBehaviorPolicySettingId,
    ShowAutoCompleteListPolicySettingId,
    UnifiedInboxPolicySettingId,
} from '../store/schema/OutlookCloudPolicyTypes';
import type { OutlookCloudPolicySettingId } from '../store/schema/OutlookCloudPolicyTypes';

export const settingIdToFeature: Record<OutlookCloudPolicySettingId, OcpsPolicyFeature> = {
    [ShowAutoCompleteListPolicySettingId.ShowAutoCompleteListOptions]:
        OcpsPolicyFeature.ShowAutoCompleteList,
    [PrivacyPolicySettingId.OptionalConnectedExperiences]: OcpsPolicyFeature.Privacy,
    [PrivacyPolicySettingId.ConnectedOfficeExperiences]: OcpsPolicyFeature.Privacy,
    // Beware of the typo "Anlayzing" — this is how the server stores it
    [PrivacyPolicySettingId.OfficeExperiencesAnalyzingContent]: OcpsPolicyFeature.Privacy,
    [PrivacyPolicySettingId.OfficeExperiencesDownloadingContent]: OcpsPolicyFeature.Privacy,
    [UnifiedInboxPolicySettingId.ShowAllAccountsView]: OcpsPolicyFeature.UnifiedInbox,
    [UnifiedInboxPolicySettingId.ShowAllAccountsViewUserOverride]: OcpsPolicyFeature.UnifiedInbox,
    [KeyboardStylesPolicySettingId.EnableKeytips]: OcpsPolicyFeature.KeyboardStyles,
    [KeyboardStylesPolicySettingId.OutlookWebKeyboardShortcutStyle]:
        OcpsPolicyFeature.KeyboardStyles,
    [KeyboardStylesPolicySettingId.OutlookWindowsKeyboardShortcutStyle]:
        OcpsPolicyFeature.KeyboardStyles,
    [KeyboardStylesPolicySettingId.KeyboardStylesUserOverride]: OcpsPolicyFeature.KeyboardStyles,
    [AlwaysShowBccPolicySettingId.AlwaysShowBccOptions]: OcpsPolicyFeature.AlwaysShowBcc,
    [AlwaysShowBccPolicySettingId.AlwaysShowBccUserOverride]: OcpsPolicyFeature.AlwaysShowBcc,
    [ReplyBehaviorPolicySettingId.DefaultReadingPaneReplyBehaviorOptions]:
        OcpsPolicyFeature.ReplyBehavior,
    [ReplyBehaviorPolicySettingId.DefaultReadingPaneReplyBehaviorUserOverride]:
        OcpsPolicyFeature.ReplyBehavior,
    [FocusedInboxPolicySettingId.FocusedInboxOptions]: OcpsPolicyFeature.FocusedInbox,
    [FocusedInboxPolicySettingId.FocusedInboxUserOverride]: OcpsPolicyFeature.FocusedInbox,
    [PresencePolicySettingId.TurnOffPresenceIntegration]: OcpsPolicyFeature.Presence,
    [PresencePolicySettingId.ConfigurePresenceIcons]: OcpsPolicyFeature.Presence,
    [NotificationsPolicySettingId.GetNotifications]: OcpsPolicyFeature.Notifications,
    [NotificationsPolicySettingId.DocumentNotifications]: OcpsPolicyFeature.Notifications,
    [NotificationsPolicySettingId.ShowDocumentNotificationsInPane]: OcpsPolicyFeature.Notifications,
    [NotificationsPolicySettingId.NotificationSettingsUserOverride]:
        OcpsPolicyFeature.Notifications,
    [AtMentionsPolicySettingId.MentionNamesWithAtSymbolOptions]: OcpsPolicyFeature.AtMentions,
    [AtMentionsPolicySettingId.MentionNamesWithAtSymbolUserOverride]: OcpsPolicyFeature.AtMentions,
};
